export default "__VITE_ASSET__BoflVzRu__"